"use client";

import { type ReactNode } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { RECAPTCHA_SITE_KEY } from "@/lib/recaptcha-client";

export function ReCaptchaProvider({ children }: { children: ReactNode }) {
  if (!RECAPTCHA_SITE_KEY) {
    return children;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_SITE_KEY}
      scriptProps={{ async: true, defer: true, appendTo: "head" }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
}
